module.exports = __webpack_public_path__ + "img/jmbcomputers.f60618fd.png";